import React, {useContext} from 'react';
import { AttendeeContext } from "../../context/attendee";

export default function useAttendee() {
	const [ attendeeProfile, checkPassword, checkTicket, logoutAttendee ] = useContext(AttendeeContext);

	return Object.assign([ attendeeProfile, checkPassword, checkTicket, logoutAttendee ], { attendeeProfile, checkPassword, checkTicket, logoutAttendee });
}